import React, { useRef, useState } from "react";
import Card from "../../../elements/Card";
import Input from "../../../form/Input";
import useClickOutside from "../../../../hooks/useClickOutside";
import { classNames } from "../../../../helpers/classNames";
import { t } from "i18next";

const ReadOnly = ({ data, onEditMode = () => {} }) => {
  return (
    <Card
      title={
        <div className="flex items-center justify-between">
          {t("Social media link")}{" "}
          <button
            type="button"
            onClick={() => {
              onEditMode();
            }}
          >
            <i className="fa-fw fa-regular fa-pen"></i>
          </button>
        </div>
      }
      bodyClass={"space-y-6"}
      className={" py-4 md:py-8 px-3 md:px-6"}
    >
      <div className="grid md:grid-cols-2 gap-4">
        {data?.socialMedia?.map((social) => (
          <div className="flex items-center gap-3 bg-slate-100 p-2 rounded-lg overflow-hidden">
            <div className="w-7 max-w-7 min-w-7">
              <i className={classNames("fa-fw", social?.icon)}></i>
            </div>
            <div class="space-y-1 flex-grow overflow-hidden">
              <div class="font-medium font-CanelaDeck !text-base !text-gray-800">
                {t(social?.name)}
              </div>
              <div class="text-text-disabled font-medium truncate">
                {social?.url || "N/A"}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

const SocialDetails = ({
  selectedProfile,
  values,
  setFieldsValue = () => {},
}) => {
  const divRef = useRef(null);
  const [readOnly, setReadOnly] = useState(true);

  useClickOutside(divRef, () => {
    setReadOnly(true);
  });

  return (
    <div ref={divRef}>
      {readOnly ? (
        <ReadOnly data={values} onEditMode={() => setReadOnly(false)} />
      ) : (
        <Card title={t("Social media link")}>
          <div className="space-y-2">
            {values?.socialMedia?.map((social, i) => (
              <Input
                key={i}
                label={t(social?.name)}
                value={social?.url}
                labelClasses={"!text-base !text-gray-800 !mb-1"}
                inputClasses="!border-surface-05 !bg-surface-04 !h-12 !font-medium !text-gray-800 !pr-10"
                inputPlaceholder={`https://www.${social?.name?.toLowerCase()}.com/accountname`}
                onChange={(e) =>
                  setFieldsValue({
                    socialMedia: values?.socialMedia?.map((item) =>
                      item?.name === social?.name
                        ? { ...item, url: e.target.value }
                        : item
                    ),
                  })
                }
              />
            ))}
          </div>
        </Card>
      )}
    </div>
  );
};

export default SocialDetails;
